export default "__VITE_ASSET__CxPtdOLX__"